import React from "react";
import 'react-calendar/dist/Calendar.css';
import { Card, CardBody, CardHeader,CardTitle, Col, Row} from "reactstrap";
import 'react-calendar/dist/Calendar.css';
import {Button, Grid, Typography} from "@material-ui/core";
import CheckIcon from '@mui/icons-material/Check';
import Divider from '@mui/material-next/Divider';
import { useEffect } from 'react';
import axios from "axios";
import Cookies from "js-cookie";
import VideocamIcon from '@mui/icons-material/Videocam';

import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { Table, TableRow, TableCell, TableBody } from '@material-ui/core';
import moment from "moment-jalali";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/joy/Tooltip";
import {NavLink} from "react-router-dom";

const cardStyle={
	borderRadius:'25px',
	padding:'5px',
}

function SessionReport(props) {

	const [data, setData] = React.useState();

	const [patientID, setPatientID] = React.useState(0);
	const [sessionDate, setSessionDate] = React.useState(0);
	const [patientDoctor, setPatientDoctor] = React.useState(0);
	const [status, setStatus] = React.useState(0);

	const [rate, setRate] = React.useState(0);
	const [pain, setPain] = React.useState(0);
	const [doshvari, setDoshvari] = React.useState(0);
	const [point, setPoint] = React.useState(0);
	const [totalTime, setTotalTime] = React.useState(0);
	const percentage = 20;

	//0 is sec and 1 is min
	const [minORSec, setMinORSec] = React.useState(1)

	const englishToPersianNumbers = (input) => {
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		// Convert numbers in the input to Persian numbers
		const convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToSolarAndPersian = (gregorianDate) => {
		// Convert Gregorian date to Jalali (Solar) date
		if (!gregorianDate) gregorianDate = '2111-11-11'
		const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

		// Convert English numbers to Persian numbers
		const persianNumbers = englishToPersianNumbers(solarDate)
		//const persianNumbers = Persian(solarDate.toString()).englishNumber().persianNumber()._str;

		return persianNumbers;
	};

	useEffect(() => {
		axios.get(`https://back.actelmon.ir/api/doctor/sessions/detail/${Cookies.get('sessionID')}/reports/`, {
			headers: {
				Authorization: `${Cookies.get('token')}` // Assuming you have a function to get the cookie value
			}
		})
			.then((response) => {
				console.error('Suc. fetching report');
				console.log(response.data)
				setData(response.data)

				let len = response.data.length
				// for total time
				let tTime = 0
				response.data.map((exercise, index) => (
					tTime += exercise.prescription.total_time == null?0:exercise.prescription.total_time
				))
				if (tTime<60){
					setMinORSec(0)
					setTotalTime(tTime)
				}else{
					setMinORSec(1)
					setTotalTime(tTime/60)
				}

				// for hardness
				var sakht = 0
				response.data.map((exercise, index) => (
					sakht += exercise.hardness_present * 100
				))
				setDoshvari(sakht/len)

				// for pain
				var dard = 0
				response.data.map((exercise, index) => (
					dard += exercise.pain_level * 100
				))
				setPain(dard/len)

				// for rate
				var r = 0
				response.data.map((exercise, index) => (
					r += exercise.repeats * 100
				))
				setRate(r/len)

				// for score
				var score = 0
				response.data.map((exercise, index) => (
					score += (((exercise.repeats + (1-exercise.hardness_present) + (1-exercise.pain_level)) / 3)*100)
				))
				setPoint(score/len)

				response.data.map((exercise, index) => {
					setPatientID(exercise.prescription.patient)
					setSessionDate(exercise.session_date)
					setPatientDoctor(exercise.session_date)
				})
			})
			.catch((error) => {
				console.error('Error fetching report:', error);
			});
	}, []);

	return (
		<>
			<div className="content">
				<Col lg="12" sm="12" style={{padding:'30px',borderRadius:'10px'}}>

					<Row lg="12" sm="12">
						<Card style={cardStyle} >

							<CardHeader className="text-right">
								<Row lg="10" sm="10" style={{margin:'15px'}}>
									<Card style={{...cardStyle, backgroundColor:'#EDEDED'}}>
										<CardBody>
											<Grid container spacing={2} alignItems="center">

												<Grid item lg={2} xs={12} container justify='center' alignItems="center">
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#000000', textAlign:'center'}}>
															شماره جلسه
														</Typography>
													</Grid>
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#138C97', textAlign:'center'}}>
															{englishToPersianNumbers(Cookies.get('sessionNum').toString())}
														</Typography>
													</Grid>
												</Grid>

												<Grid item lg={2} xs={12} container justify='center' alignItems="center">
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#000000', textAlign:'center'}}>
															کد شناسایی بیمار
														</Typography>
													</Grid>
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#138C97', textAlign:'center'}}>
															{englishToPersianNumbers(patientID.toString())}
														</Typography>
													</Grid>
												</Grid>

												<Grid item lg={2} xs={12} container justify='center' alignItems="center">
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#000000', textAlign:'center'}}>
															تاریخ جلسه
														</Typography>
													</Grid>
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#138C97', textAlign:'center'}}>
															{convertToSolarAndPersian(sessionDate)}
														</Typography>
													</Grid>
												</Grid>

												<Grid item lg={2} xs={12} container justify='center' alignItems="center">
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#000000', textAlign:'center'}}>
															 فیزیوتراپیست
														</Typography>
													</Grid>
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#138C97', textAlign:'center'}}>
															{Cookies.get('doctorName')}
														</Typography>
													</Grid>
												</Grid>

												<Grid item lg={2} xs={12} container justify='center' alignItems="center">
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#000000', textAlign:'center'}}>
															وضعیت
														</Typography>
													</Grid>
													<Grid item xs={12}>
														<Typography gutterBottom style={{color:'#138C97', textAlign:'center'}}>
															انجام شده
														</Typography>
													</Grid>
												</Grid>

												<Grid item lg={2} xs={12} container justify='center' alignItems="center">
													<Tooltip title="تماس تصویری" variant="soft" arrow>
														<IconButton aria-label="edit" size="large" /*onClick={() => handleIconEdit(item.id)}*/>
															<VideocamIcon fontSize="inherit" style={{ color: '#138C97',fontSize:'40px' }} />
														</IconButton>
													</Tooltip>
												</Grid>

											</Grid>
										</CardBody>
									</Card>
								</Row>
							</CardHeader>

							<CardHeader className="text-right">
								<CardTitle tag="h3" style={{color:'#757575',fontWeight:'bold'}}>خلاصه جلسه</CardTitle>
							</CardHeader>

							<CardBody>
								<Grid container spacing={2} style={{direction:'rtl', textAlign:'right' , padding:'10px'}} alignItems="center">

									<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
										<Typography gutterBottom style={{color:'#EBAB60', marginLeft:'5px'}}>
											 بازدهی:
										</Typography>
										<Typography gutterBottom style={{color:'#000000'}}>
											{englishToPersianNumbers(rate.toFixed(0).toString())} %
										</Typography>
									</Grid>
									<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
										<Typography gutterBottom style={{color:'#EBAB60', marginLeft:'5px'}}>
											درد:
										</Typography>
										<Typography gutterBottom style={{color:'#000000'}}>
											{englishToPersianNumbers(pain.toFixed(0).toString())} %
										</Typography>
									</Grid>
									<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
										<Typography gutterBottom style={{color:'#EBAB60', marginLeft:'5px'}}>
											سختی:
										</Typography>
										<Typography gutterBottom style={{color:'#000000'}}>
											{englishToPersianNumbers(doshvari.toFixed(0).toString())} %
										</Typography>
									</Grid>
									<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
										<Typography gutterBottom style={{color:'#EBAB60', marginLeft:'5px'}}>
											امتیاز:
										</Typography>
										<Typography gutterBottom style={{color:'#000000'}}>
											{englishToPersianNumbers(point.toFixed(0).toString())} %
										</Typography>
									</Grid>
									<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
										<Typography gutterBottom style={{color:'#EBAB60', marginLeft:'5px'}}>
											زمان کل:
										</Typography>
										<Typography gutterBottom style={{color:'#000000'}}>
											{
												minORSec === 0 ?
													englishToPersianNumbers(totalTime==null?0:totalTime.toFixed(0).toString()) :
													englishToPersianNumbers(totalTime==null?0:totalTime.toFixed(2).toString())
											}
											{minORSec === 0 ? ' ثانیه' : ' دقیقه'}
										</Typography>
									</Grid>

									<Grid item xs={12}>

									</Grid>

									<Grid container direction="row" alignItems="center" justify="flex-start" spacing={2}>
										{data ? data.map((exercise, index) => (
											<React.Fragment key={index}>

												<Grid item xs={12}>
													<Divider style={{ backgroundColor: '#000000' }} />
												</Grid>

												<Grid item lg={3} xs={12} container alignItems="center" justify="center">
													<img src={exercise.prescription.exercises[0].photo} style={{ width: '100%', height: 'auto' }} />
												</Grid>

												<Grid item lg={4} xs={12} container alignItems="flex-end">
													<Grid container>
														<Grid item xs={12}>
															<Typography gutterBottom style={{color:'#138C97', fontSize: 'x-large'}}>
																{exercise.prescription.exercises[0].name}
															</Typography>
														</Grid>
														<Grid item xs={12}>
															<Typography paragraph>
																انجام شده<CheckIcon style={{color:'#138C97', margin:'5px'}}/>
															</Typography>
														</Grid>
													</Grid>
												</Grid>

												<Grid item lg={2} xs={12} style={{padding:'40px'}} container alignItems="center" justify="center">
													<CircularProgressbar
														value={exercise.id ?
															(((exercise.repeats + (1-exercise.hardness_present) + (1-exercise.pain_level)) / 3)*100).toFixed(0) : 0}
														text={exercise.id ?
															`${englishToPersianNumbers(
																(((exercise.repeats + (1-exercise.hardness_present) + (1-exercise.pain_level)) / 3)*100).toFixed(0).toString()
															)} امتیاز ` :
															'- امتیاز '}

														styles={{
															root: {}, // Add any styles to the root container if needed
															path: {
																stroke: '#138C97', // Set the color of the circular path
															},
															trail: {
																stroke: 'rgba(19,140,151,0.2)', // Set the color of the trail
															},
															text: {
																fill: '#138C97', // Set the color of the text
																fontSize: '16px', // You can adjust the font size as needed
															},
														}}
													/>
												</Grid>

												<Grid item lg={3} xs={12} container alignItems="center" justify="center">
													<Table style={{ border: '1px solid #e0e0e0'}}>
														<TableBody>
															<TableRow>
																<TableCell align={"center"}>
																	بازدهی
																</TableCell>
																<TableCell
																	align={"center"}
																	style={{ borderRight: '1px solid #e0e0e0'}}>
																	{englishToPersianNumbers((exercise.repeats * 100).toFixed(0).toString())}%
																</TableCell>
															</TableRow>

															<TableRow>
																<TableCell align={"center"}>
																	درد
																</TableCell>
																<TableCell
																	align={"center"}
																	style={{ borderRight: '1px solid #e0e0e0'}}>
																	{englishToPersianNumbers((exercise.pain_level * 100).toFixed(0).toString())}%
																</TableCell>
															</TableRow>

															<TableRow>
																<TableCell align={"center"}>
																	سختی
																</TableCell>
																<TableCell
																	align={"center"}
																	style={{ borderRight: '1px solid #e0e0e0'}}>
																	{englishToPersianNumbers((exercise.hardness_present * 100).toFixed(0).toString())}%
																</TableCell>
															</TableRow>
														</TableBody>
													</Table>
												</Grid>

												<Grid item lg={10} xs={12}>
													<Grid container direction="row" spacing={2} alignItems="center">
														<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
															<Typography variant="body1" style={{color:'#757575'}}>تعداد ست: </Typography>
															<Typography variant="body1" style={{color:'#138C97', margin:'5px'}}>
																{englishToPersianNumbers(exercise.prescription.sets.toString())}
															</Typography>
														</Grid>
														<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
															<Typography variant="body1" style={{color:'#757575'}}>تعداد تکرار: </Typography>
															<Typography variant="body1" style={{color:'#138C97', margin:'5px'}}>
																{englishToPersianNumbers(exercise.prescription.repeat.toString())}
															</Typography>
														</Grid>
														<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
															<Typography variant="body1" style={{color:'#757575'}}>زمان کل: </Typography>
															<Typography variant="body1" style={{color:'#138C97', margin:'5px'}}>
																{exercise.prescription.total_time==null?"-":englishToPersianNumbers(exercise.prescription.total_time.toString())}
															</Typography>
															<Typography variant="body1" style={{color:'#138C97'}}>{exercise.prescription.total_time==null?"":"ثانیه"}</Typography>
														</Grid>
														<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
															<Typography variant="body1" style={{color:'#757575'}}>زمان Hold: </Typography>
															<Typography variant="body1" style={{color:'#138C97', margin:'5px'}}>
																{exercise.prescription.hold_time==null?"-":englishToPersianNumbers(exercise.prescription.hold_time.toString())}
															</Typography>
															<Typography variant="body1" style={{color:'#138C97'}}>{exercise.prescription.hold_time==null?"":"ثانیه"}</Typography>
														</Grid>
														<Grid item lg={2} xs={12} alignItems="center" style={{ display: 'flex' }}>
															<Typography variant="body1" style={{color:'#757575'}}>زمان Rest: </Typography>
															<Typography variant="body1" style={{color:'#138C97', margin:'5px'}}>
																{exercise.prescription.rest_time==null?"-":englishToPersianNumbers(exercise.prescription.rest_time.toString())}
															</Typography>
															<Typography variant="body1" style={{color:'#138C97'}}>{exercise.prescription.rest_time==null?"":"ثانیه"}</Typography>
														</Grid>
													</Grid>
												</Grid>

											</React.Fragment>
										)) :
											<div>
												دیتایی وجود ندارد
											</div>
										}

										<Grid item xs={12}>
											<Divider style={{ backgroundColor: '#000000' }} />
										</Grid>

										<Grid container spacing={2} style={{ direction: 'rtl', textAlign: 'right' }} alignItems="center">
											<Grid item xs={10}>
											</Grid>
											<Grid item lg={2} xs={12}>
												<NavLink
													to={'/rtl/patientprofile'}
													className="nav-link"
												>
													<Button
														variant="outlined"
														fullWidth
														style={{backgroundColor:'#DD8E9C' ,color:'white'}}
														onClick={() => console.log('my log','ret1')}
													>
														بازگشت
													</Button>
												</NavLink>
												<Grid item xs={1}>
												</Grid>
											</Grid>
										</Grid>
									</Grid>

								</Grid>
							</CardBody>
						</Card>
					</Row>

				</Col>
			</div>
		</>
	);
}

export default SessionReport;
